<template>
    <div class="add-department-config">
        <div class="config-field">
            <label>Departman Seçimi</label>
            <a-select
                v-model="localConfig.departmentId"
                placeholder="Departman seçin"
                style="width: 100%;"
                :filter-option="filterOption"
                @change="emitChange"
            >
                <a-select-option
                    v-for="dept in departments"
                    :key="dept._id"
                    :value="dept._id"
                >
                    {{ getDepartmentName(dept) }}
                </a-select-option>
            </a-select>
            <small>Seçilen departman kişinin ilgili departmanlar listesine eklenecektir</small>
        </div>

        <!-- Apply to Conversation (only if when = chat_opened) -->
        <div v-if="whenType === 'chat_opened'" class="config-field">
            <a-checkbox 
                v-model="localConfig.applyToConversation"
                @change="emitChange"
            >
                Konuşmaya da uygula
            </a-checkbox>
            <small>Aktif edilirse, açılan konuşmanın departmanı da bu departman olarak ayarlanır</small>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import log2 from "../../../../../../utils/log2";

const log = log2("AddDepartmentConfig");

export default {
    name: "AddDepartmentConfig",
    props: {
        value: {
            type: Object,
            required: true
        },
        whenType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            localConfig: {
                departmentId: null,
                applyToConversation: false
            }
        };
    },
    computed: {
        ...mapState({
            departments: state => state.subject.subjects.data
        })
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal && JSON.stringify(newVal) !== JSON.stringify(this.localConfig)) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        },

        getDepartmentName(dept) {
            return dept.languageContent[this.$i18n.locale].name;
        },

        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.add-department-config {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }

        small {
            display: block;
            color: #999;
            font-size: 12px;
            margin-top: 6px;
        }
    }
}
</style>

